import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsArray, IsOptional, ValidateNested, IsEnum } from "class-validator";
import GenericTableResponse from "../GenericTableResponse";
import CriterionItemRequest from "../filters/criterions/CriterionItemRequest";
import { AUTOMATIC_REPORT_PERIOD_TYPE_ENUM } from "@/static/automaticReportPeriodTypeEnum";

export class AutomaticReportEdit {
  @Expose()
  @IsNumber()
  scheduleId!: number;
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsString()
  generatorType!: string;
  @Expose()
  @IsString()
  culture!: string;
  @Expose()
  @IsString()
  emailAddresses!: string;
  @Expose()
  @IsNumber()
  @IsOptional()
  mailConfigurationId!: number | null;
  @Expose()
  @IsOptional()
  @IsString()
  password!: string | null;
}

export class AutomaticReportAdd {
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsString()
  generatorType!: string;
  @Expose()
  @IsString()
  culture!: string;
  @Expose()
  @IsNumber()
  reportType!: number;
  @Expose()
  @IsOptional()
  @IsString()
  password!: string | null;

  @Expose()
  @IsString()
  startDate!: string;
  @Expose()
  @IsEnum(AUTOMATIC_REPORT_PERIOD_TYPE_ENUM)
  periodType!: AUTOMATIC_REPORT_PERIOD_TYPE_ENUM;
  @Expose()
  @IsNumber()
  @IsOptional()
  days!: number | null;
  @Expose()
  @IsNumber()
  @IsOptional()
  periodDays!: number | null;
  @Expose()
  @IsString()
  emailAddresses!: string;
  @Expose()
  @IsNumber()
  @IsOptional()
  mailConfigurationId!: number | null;
}

export class AutomaticReport {
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsArray()
  criterions!: Array<CriterionItemRequest>;
  @Expose()
  @IsString()
  generatorType!: string;
  @Expose()
  @IsString()
  culture!: string;
  @Expose()
  @IsString()
  password!: string;

  @Expose()
  @IsString()
  emailAddresses!: string;
  @Expose()
  @IsString()
  startDate!: string;
  @Expose()
  @IsEnum(AUTOMATIC_REPORT_PERIOD_TYPE_ENUM)
  periodType!: AUTOMATIC_REPORT_PERIOD_TYPE_ENUM;
  @Expose()
  @IsNumber()
  @IsOptional()
  days!: number | null;
  @Expose()
  @IsString()
  last!: string;
  @Expose()
  @IsString()
  next!: string;

  @Expose()
  @IsNumber()
  scheduleId!: number;
  @Expose()
  @IsNumber()
  @IsOptional()
  recordStampId!: number | null;
  @Expose()
  @IsNumber()
  @IsOptional()
  mailConfigurationId!: number | null;
}

export class AutomaticReportResponse extends GenericTableResponse<AutomaticReport> {
  @Type(() => AutomaticReport)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<AutomaticReport>;
}
